import { AdminSearch } from ".";
import * as React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as redux from "redux";
import * as Actions from "../../actions";
import * as Comp from "../../components";
import { Paths } from "../../constants";
import * as M from "../../models";
import { AppState } from "../../store";
import { AuthHelper, ReactHelper } from "../../utils";
import { Icon } from "../generic";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    user: AuthHelper.getBasicUserProfile(AuthHelper.tokenData(state.auth)),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    toggleOpen: (open: boolean) => dispatch(Actions.AdminMenu.toggleOpen(open)),
});

interface OwnProps {
    sectionTitle: string;
}

type ConnectedState = Comp.Base.DefaultConnectedState & {
    user: M.User.BasicProfile;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    toggleOpen: (open: boolean) => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class AdminHeaderNavComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {
        return <div id="nav">
            <div id="nav-toggle">
                <a href="#" onClick={(e) => this.onMenuClick(e)}>
                    <Icon icon="bars" /> {this.props.sectionTitle}
                </a>
            </div>

            <AdminSearch />

            <div id="account-nav">
                <Link className="btn btn-link" to={Paths.Home}>Live site</Link>
                <BS.DropdownButton id="account-nav-dropdowm" title={M.Generic.PersonHelper.getFullName(this.props.user)}>
                    <BS.MenuItem divider />
                    <BS.MenuItem className="dropdown-item" onClick={() => this.props.goto(Paths.Account.Logout)}>
                        Sign out <Icon icon="sign-out" />
                    </BS.MenuItem>
                </BS.DropdownButton>
            </div>
        </div>;
    }

    private onMenuClick(e: React.MouseEvent<HTMLAnchorElement>) {
        this.props.toggleOpen(true);
        return ReactHelper.emptyClick(e);
    }
}

export const AdminHeaderNav: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(AdminHeaderNavComponent);



// WEBPACK FOOTER //
// ./src/components/admin/AdminHeaderNav.tsx